/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutSelectionRequest
 */
export interface CarveOutSelectionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CarveOutSelectionRequest
     */
    carve_out_ids: Array<string>;
}

/**
 * Check if a given object implements the CarveOutSelectionRequest interface.
 */
export function instanceOfCarveOutSelectionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "carve_out_ids" in value;

    return isInstance;
}

export function CarveOutSelectionRequestFromJSON(json: any): CarveOutSelectionRequest {
    return CarveOutSelectionRequestFromJSONTyped(json, false);
}

export function CarveOutSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutSelectionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carve_out_ids': json['carve_out_ids'],
    };
}

export function CarveOutSelectionRequestToJSON(value?: CarveOutSelectionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carve_out_ids': value.carve_out_ids,
    };
}

